import dayjs from "dayjs";
import axios from "axios";
import deaths from "./DeathList";
import PaperList from "./PaperList";

export const GET_PAPERS = "GET_PAPERS";
export const FILTER_PAPERS = "FILTER_PAPERS";
export const RESET_FILTER = "RESET_FILTER";
export const SET_FILTER = "SET_FILTER";
export const SET_COUNTRY = "SET_COUNTRY";
export const SET_DAYS = "SET_DAYS";
export const SET_ERROR = "SET_ERROR";

export const getPapers = (days, country) => {
  const dateNow = dayjs().format('YYYY/MM/DD')
  const dateMinusDays = dayjs().subtract(days, "day").format("YYYY/MM/DD");
  const dateParams = `${dateMinusDays}"[Date - Publication] : "${dateNow}"[Date - Publication])`;

  const urlunencoded =
    `((((((((((((((((((((((((((((((((((((((((((((((((((((((((((apoptosis[Text Word]) OR (BCL-XL[Text Word]) OR (BCL-2[Text Word])) OR (BCL-W[Text Word])) OR (MCL-1[Text Word])) OR (BFL-1[Text Word])) OR (BIM[Text Word])) OR (BH3-mimetic[Text Word])) OR (BH3 mimetic[Text Word])) OR (BMF[Text Word])) OR (HRK[Text Word])) OR (BID[Text Word])) OR (NOXA[Text Word])) OR (PUMA[Text Word])) OR (BIK[Text Word])) OR (BAX[Text Word])) OR (BAK[Text Word])) OR (BOK[Text Word])) OR (extrinsic apoptosis[Text Word])) OR (Fas[Text Word])) OR (TRAIL[Text Word])) OR (TNF[Text Word])) OR (Smac mimetic[Text Word])) OR (CD95[Text Word])) OR (FADD[Text Word])) OR (c-FLIP[Text Word])) OR (TRADD[Text Word])) OR (TRAF2[Text Word])) OR (TRAF6[Text Word])) OR (c-IAP1[Text Word])) OR (c-IAP2[Text Word])) OR (LUBAC[Text Word])) OR (DR4[Text Word])) OR (DR5[Text Word])) OR (caspase-8[Text Word])) OR (caspase-10[Text Word])) OR (necroptosis[Text Word])) OR (RIPK1[Text Word])) OR (RIPK3[Text Word])) OR (MLKL[Text Word])) OR (ripoptosome[Text Word])) OR (pyroptosis[Text Word])) OR (inflammasome[Text Word])) OR (gasdermin[Text Word]))  OR (GSDMD[Text Word])) OR (GSDME[Text Word])) OR (NLRP3[Text Word])) OR (NLRP1[Text Word])) OR (caspase-5[Text Word])) OR (caspase-4[Text Word])) OR (caspase-1[Text Word])) OR (ferroptosis[Text Word])) OR (entosis[Text Word])) OR (extracellular trap[Text Word]) OR (NETosis[Text Word])) OR (parthanatos[Text Word])) OR (autophagy-dependent cell death[Text Word])) OR (autophagic cell death[Text Word])) OR (immunogenic cell death[Text Word])) AND (${country}[Affiliation]) AND ("`;

  const urlEncoded = encodeURIComponent(urlunencoded);
  const dateParamsEncoded1 = encodeURIComponent(dateParams);

  const url1 = `https://eutils.ncbi.nlm.nih.gov/entrez/eutils/esearch.fcgi?db=pubmed&retmode=json&retmax=10000&term=${urlEncoded}${dateParamsEncoded1}&api_key=${process.env.REACT_APP_PUBMED_API_KEY}`;

  let idlist = [];

  return async (dispatch) => {
    await axios.get(url1).then((response) => {
      idlist = [...new Set(response.data.esearchresult.idlist)];
    });

    let idlistString = idlist.toString();

    let paperList = [];
    if (idlistString.length){
    await axios
      .get(
        `https://eutils.ncbi.nlm.nih.gov/entrez/eutils/esummary.fcgi?db=pubmed&retmode=json&id=${idlistString}`
      )
      .then((response) => {
        paperList = PaperList(response.data.result);
      })
      .catch(err => dispatch({ type: SET_ERROR, days: 7, error: true, loading: false }));
    }
    const paperListSorted = paperList.sort((a,b) => parseInt(b.id)-parseInt(a.id))
    
    dispatch({ type: GET_PAPERS, paperList: paperListSorted, aloading: false });
  };
};

export const filterPapers = (filter, days, country) => {
  const dateNow = dayjs().format('YYYY/MM/DD')
  const dateMinusDays = dayjs().subtract(days, "day").format("YYYY/MM/DD");
  const dateParams = ` AND (${country}[Affiliation]) AND ("${dateMinusDays}"[Date - Publication] : "${dateNow}"[Date - Publication])`;
  
  
  const deathType = deaths.find(
    (death) => Object.keys(death).toString() === filter
  );
  const urlunencoded = Object.values(deathType).toString();

  const urlEncoded = encodeURIComponent(urlunencoded);
  const dateParamsEncoded1 = encodeURIComponent(dateParams);

  const url1 = `https://eutils.ncbi.nlm.nih.gov/entrez/eutils/esearch.fcgi?db=pubmed&retmode=json&retmax=10000&term=${urlEncoded}${dateParamsEncoded1}&api_key=${process.env.REACT_APP_PUBMED_API_KEY}`;

  let idlist = [];

  return async (dispatch) => {
    await axios.get(url1).then((response) => {
      idlist = [...new Set(response.data.esearchresult.idlist)];
    });

    let idlistString = idlist.toString();
    let filterList = [];
    if (idlistString.length){
    await axios
      .get(
        `https://eutils.ncbi.nlm.nih.gov/entrez/eutils/esummary.fcgi?db=pubmed&retmode=json&id=${idlistString}`
      )
      .then((response) => {
        filterList = PaperList(response.data.result);
      })
      .catch((error) => console.log("Error" + error));
    }
    const filterListSorted = filterList.sort((a,b) => parseInt(b.id)-parseInt(a.id))
    dispatch({ type: FILTER_PAPERS, filterList:filterListSorted , loading: false });
  };
};

export const setFilter = (filter) => {
  return { type: SET_FILTER, filter, loading: false };
};

export const resetFilter = () => {
  return { type: RESET_FILTER, loading: false };
};

export const selectCountry = (country) => {
  return { type: SET_COUNTRY, country, loading: false };
};

export const selectDays = (days) => {
  return { type: SET_DAYS, days, loading: false };
};

export const resetError = () => {
  return { type: SET_ERROR, error: false, loading: false };
};